module.exports = __webpack_public_path__ + "img/g2.23ac9ce1.jpg";